
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { QueryStringValue } from '@/features/query-string/views/QueryString.vue';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component
export default class QueryStringTableRow extends Mixins(ResponsivenessMixin) {
  @Prop({ required: true }) item!: QueryStringValue;

  @Prop({ required: true }) endpointName!: string;

  get isRequired(): boolean {
    return this.item.required || !!this.item.requiredForInternational;
  }
}
